import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { Issue } from '../../../../IssueTrackerContext/types'
import {
  IssueStatus,
  alphabeticalCompare,
  alphabeticalSort,
} from '@cims-online/shared'
import StatusButton from './components/StatusButton'
import { HelpMessage } from 'utils/constants'

export function useStatus(): CIMSColumn<Issue> {
  return {
    title: 'Status',
    help: HelpMessage.Issues.IssueTracker.Status,
    render: (issue) => <StatusButton {...issue} />,
    width: 200,
    filter: {
      type: 'default',
      with: 'items',
      items: IssueStatus.sort(alphabeticalSort('priority')).map(
        ({ id, name, description }) => ({
          text: name,
          tooltip: description,
          value: id,
        })
      ),
      key: 'statusId',
    },
    sort: {
      with: 'callback',
      default: 'ascend',
      priority: 0,
      onCompare: (a, b) => {
        const A = IssueStatus.fromIdOrFail(a.statusId)
        const B = IssueStatus.fromIdOrFail(b.statusId)
        return alphabeticalCompare(A, B, 'priority')
      },
    },
  }
}
